import React, { useState } from 'react';
import AppRoutes from './routes.js';
import './App.css';
import './shared/styles/variables.scss';
import './shared/styles/materialTable.scss';
import {
	ThemeProvider,
	StyledEngineProvider,
	createTheme,
} from '@mui/material/styles';
import LanguageSelector from './utils/LanguageSelector.js';
import { withTranslation } from 'react-i18next';
import InputContext from './context/inputContext';
//import makeStyles from '@mui/styles/makeStyles';

const theme = createTheme();

// const useStyles = makeStyles((theme) => {
//   root: {
//     // some CSS that accesses the theme
//   }
// });

function App() {
	const [isChanged, setIsChanged] = useState(false);
	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
				<div className='App'>
					{/* <div className='langselector'>
            <LanguageSelector />
          </div> */}
					<InputContext.Provider value={{ isChanged, setIsChanged }}>
						<AppRoutes />
					</InputContext.Provider>
				</div>
			</ThemeProvider>
		</StyledEngineProvider>
	);
}

export default withTranslation()(App);
